import { GuestLoginParams } from '../types';
import { post } from './axios';

const URLS = {
  guestLogin: 'ecomm-guest-login'
};

const guestApi = {
  guestLogin: (params: GuestLoginParams) => post(URLS.guestLogin, params)
};

export default guestApi;
